/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_3_DescInputs */

const en_mk_sec_3_desc = /** @type {(inputs: Mk_Sec_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Rupiah ceiling per agent per month; work pauses and waits once it's hit.`)
};

const id_mk_sec_3_desc = /** @type {(inputs: Mk_Sec_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batas Rupiah per agen per bulan; kerja berhenti dan menunggu bila tercapai.`)
};

/**
* | output |
* | --- |
* | "A Rupiah ceiling per agent per month; work pauses and waits once it's hit." |
*
* @param {Mk_Sec_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_3_desc = /** @type {((inputs?: Mk_Sec_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_3_desc(inputs)
	return en_mk_sec_3_desc(inputs)
});